"use strict";
var mat4 = require('gl-matrix/src/gl-matrix/mat4');
var Camera = (function () {
    function Camera(fov, near, far) {
        this.fov = fov;
        this.near = near;
        this.far = far;
        this.viewMatrix = mat4.create();
        this.projectionMatrix = mat4.create();
    }
    return Camera;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Camera;
//# sourceMappingURL=Camera.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/cameras/Camera.js
 ** module id = 118
 ** module chunks = 0
 **/